import Exception from "./abstracts/Exception";

export default class NotFoundException extends Exception {
  public name = "NotFound";
}
